
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useAvatarBundleAdd } from '@/modules/avatar/bundle/model/add';
import { AvatarBundleOptions } from '@/modules/avatar/bundle/model/mixins';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BUNDLE.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, create } = useAvatarBundleAdd();

        return { v$, model, create, AvatarBundleOptions };
    }
});
